import dayjs from "dayjs";

export const getDateFourteenDaysFromNow = () => {
  const today = dayjs().startOf("day");
  const thirtyDaysFromNow = today.add(14, "day");
  return thirtyDaysFromNow.toDate();
};
